module.exports = __webpack_public_path__ + "static/media/helidon.ae5de818.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helidon.svg
// module id = 531
// module chunks = 0